module.exports = __webpack_public_path__ + "static/media/KN.fafcf25c.svg";